import { defineStore } from 'pinia'
import type { Newscenter, Language } from '~/types'

export const useNewscenterStore = defineStore('newscenter', {
    state: () => ({
        newscenter: null as Newscenter | null,
        newscenterLoaded: false,
    }),

    actions: {
        setNewscenter(newscenter: Newscenter) {
            this.newscenter = newscenter
        },
        async init() {
            await this.fetchNewscenter();
        },
        async fetchNewscenter(force = false) {
            if (this.newscenterLoaded && !force) return

            const { $api } = useNuxtApp();

            await $api.get("/newscenters")
                .then((response) => {
                    this.setNewscenter(response.data[0]);
                }).catch((error) => {
                    console.error(error);
                }).finally(() => {
                    this.newscenterLoaded = true;
                })

        },
        clear() {
            this.newscenter = null
        }
    }
})